import React, { FC } from "react";
import { Field, useFormState } from "react-final-form";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import Editor from "../../../../components/AccordionList/Editor";

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
  errorMessage: {
    display: "block",
    color: "#f8202d",
    height: 0,
    fontSize: 14,
    textAlign: "right",
    fontWeight: 500,
  },
}));

const PrivateClassDescription: FC = () => {
  const classes = useStyles();
  const { submitFailed, dirtySinceLastSubmit, submitErrors } = useFormState();

  const hasError = submitFailed && !dirtySinceLastSubmit;
  const error = hasError ? submitErrors?.description : undefined;

  return (
    <Grid item xs={12}>
      <Typography className={classes.title}>
        Description *
      </Typography>
      <Field name="description">
        {({ input }) => (
          <>
            <Editor
              textData={input.value as string}
              setData={input.onChange}
            />
            {error && (
              <Typography className={classes.errorMessage} color="error" variant="caption">
                {error}
              </Typography>
            )}
          </>
        )}
      </Field>
    </Grid>
  );
};

export default PrivateClassDescription;
